import {
  type CreativeScore,
  type CreativeScoreComponent,
  type CreativeScoreComponentName,
  creativeScoreComponentLabel,
  orderedScoreComponents,
} from '../../data/creativeScore.js';

export interface WeakFactor {
  weakName: CreativeScoreComponentName;
  weakLabel: string;
  weakScore: number;
  strongLabel: string;
  strongScore: number;
}

type ScoredEntry = [CreativeScoreComponentName, CreativeScoreComponent & { score: number }];

function isScored(
  entry: [CreativeScoreComponentName, CreativeScoreComponent],
): entry is ScoredEntry {
  return entry[1].score !== null && entry[1].insufficientSample !== true;
}

export function weakFactorOf(
  components: CreativeScore['components'],
  leadingKpiLabel: string,
): WeakFactor | null {
  const scored = orderedScoreComponents(components).filter(isScored);
  if (scored.length < 2) return null;

  const weak = scored.reduce((min, entry) => (entry[1].score < min[1].score ? entry : min));
  const strong = scored
    .filter(([name]) => name !== weak[0])
    .reduce((max, entry) => (entry[1].score > max[1].score ? entry : max));

  const labels = creativeScoreComponentLabel(leadingKpiLabel);
  return {
    weakName: weak[0],
    weakLabel: labels[weak[0]],
    weakScore: weak[1].score,
    strongLabel: labels[strong[0]],
    strongScore: strong[1].score,
  };
}

export function weakFactorSentence(factor: WeakFactor): string {
  return `${factor.weakLabel} is the weak factor at ${Math.round(factor.weakScore)} ${factor.strongLabel} still scores ${Math.round(factor.strongScore)}.`;
}
